import { createSlice } from "@reduxjs/toolkit";

 
const initialState: PhoneNumber = {
  prefixes: {
    mobNo: "91",
    whatsappNo: "91",
  },
};

interface PhoneNumber {
  prefixes: {
    mobNo: string; 
    whatsappNo: string;  
  };
}
export const phoneNoData = createSlice({
  name: "phoneNoData",
  initialState,
  reducers: {
    setPhoneNo: (state, action) => {
      const { inputName, value } = action.payload;

      return {
        ...state,
        prefixes: {
          ...state.prefixes,
          [inputName]: value,
        },
      };
    },

    setContactMobNo: (state, action) => {
      const { inputName, value } = action.payload;

      return {
        ...state,
        prefixes: {
          ...state.prefixes,
          [inputName]: value || "91",
        },
      };
    },

    resetPhoneNo: (state) => {
      return { ...state, prefixes: { mobNo: "91", whatsappNo: "91" } };
    },
  },
});

export const { setPhoneNo, setContactMobNo, resetPhoneNo } =
  phoneNoData.actions;

export default phoneNoData.reducer;
